import { SKELETON_WIDTHS, Skeleton, skeletonWidth } from '@forecastify/ui';

/**
 * The two small pieces Kezdőlap's cards share. ⚠️ 16 Oct 2026 · the collapsible `HomeSection`
 * and the `SectionStats` strip went with the reworked homescreen, which has neither.
 */

/**
 * Placeholder rows for a home section's list before its first answer — the section's own empty
 * sentence would say *nothing here* while the rows are arriving. `tall` is the two-line row the
 * leave lists draw.
 */
export function SectionSkeletonRows({
  count = 3,
  tall = false,
}: {
  readonly count?: number;
  readonly tall?: boolean;
}) {
  return (
    <div aria-hidden>
      {SKELETON_WIDTHS.slice(0, count).map((_widths, index) => (
        <div
          key={`skeleton-${String(index)}`}
          className={`flex items-center gap-3 border-b px-4 ${tall ? 'h-[50px]' : 'h-9'}`}
        >
          <div className="min-w-0 flex-1">
            <Skeleton width={skeletonWidth(index, 0)} />
          </div>
          <Skeleton width="48px" />
        </div>
      ))}
    </div>
  );
}

/** The mockup's status dot + word, used by both request lists. */
export function StatusDot({ color, label }: { readonly color: string; readonly label: string }) {
  return (
    <span className="flex shrink-0 items-center gap-1.5">
      <span className="size-2 rounded-full" style={{ background: color }} />
      <span className="text-[11.5px]">{label}</span>
    </span>
  );
}
